import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

function SectionSix({ dataSet }: any) {
  const dataImage = dataSet.filter((item: any) => item.key.startsWith('image'));
  const datatext = dataSet.filter((item: any) => item.key.startsWith('text'));
  const link = dataSet.filter((item: any) => item.key.startsWith('link'));
  return (
    <SectionWrapper className='container'>
      <div className='section-inspire'>
        <div className='title-text'>{find(dataSet, { key: 'title-text' })?.value}</div>
        <img className='logo' src={find(dataSet, { key: 'title-image' })?.value} />
        <div className='title-text-2'>{find(dataSet, { key: 'title-text-2' })?.value}</div>
      </div>
      <div className='section-partners'>
        <div className='title-text'>{find(dataSet, { key: 'partner-text' })?.value}</div>
        <div className='partner-list'>
          {dataImage.map((item: any, index: number) => (
            <a href={`${link?.[index]?.value}`} className='flex' target='_blank'>
              <img className='circle-image' src={item.value} key={index} />
              {!isEmpty(datatext[index]) && <span>{datatext[index].value}</span>}
            </a>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 10px;
  .container {
    position: relative;
    width: 100%;
  }
  .section-inspire {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin-bottom: 70px; */
    .title-text {
      font-size: 36px;
      font-weight: bolder;
      margin-bottom: 20px;
      text-align: center;
      cursor: context-menu;
    }
    .logo {
      width: 17%;
      margin-bottom: 10px;
      @media (max-width: 767px) {
        width: 40%;
      }
    }
    .title-text-2 {
      font-size: 28px;
      text-transform: uppercase;
      color: rgb(61, 61, 61);
      font-weight: bolder;
      text-align: center;
      letter-spacing: 1px;
      text-shadow: 0px 1px, 1px 0px, 1px 1px;
      cursor: context-menu;
    }
  }
  .section-partners {
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 30px;
    @media (max-width: 767px) {
      padding-top: 40px;
    }
    .title-text {
      color: #3d3d3d;
      font-size: 28px;
      font-weight: 600;
      text-shadow: 0px 1px, 1px 0px, 1px 1px;
      letter-spacing: 2px;
      cursor: context-menu;
      @media (max-width: 767px) {
        font-size: 18px;
      }
    }
    .partner-list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 40px;
      grid-row-gap: 10px;
    }
    .flex {
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 0 5px;
      gap: 12px;
      span {
        font-size: 18px;
        text-transform: uppercase;
        color: rgb(61, 61, 61);
        font-weight: 400;
        text-align: center;
        letter-spacing: 1px;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
        @media (max-width: 768px) {
          font-size: 10px;
        }
      }
    }
    .circle-image {
      border-radius: 50%;
      width: 50%;

      @media (max-width: 767px) {
        width: 80%;
      }
    }
  }
`;

export default SectionSix;
